"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Example : FW_SF_00_00_00_ARCH_dev
 */
exports.serial = new RegExp('^FW_(WM|SF|CY|RP|POD|SP)_(\\d{1,2})_(\\d{1,2})_(\\d{1,2})_([A-Z0-9]*)_(dev|alpha|beta|rc|stable|debug)$');
/**
 * Example : FW_ZT_00_00_00_SF_00_00_dev
 */
exports.serialv2 = new RegExp('^FW_ZT_(\\d{1,2})_(\\d{1,2})_(\\d{1,2})_(WM|SF|CY|RP|POD|SP)_(\\d{1,2})_(\\d{1,2})_(dev|alpha|beta|rc|stable|debug)$');
exports.default = {
    serial: exports.serial,
    serialv2: exports.serialv2
};
//# sourceMappingURL=firmware.js.map